export default {
    getNotifications(state) {
        return state.notifications;
    },
    getNotificationsQuantity(state) {
        return state.notificationsQuantity;
    },
};
